import log from "../utils/log";

export class BikehubMembership {
  init() {
    this.updateActiveKind(this.activeMembershipKind());

    const self = this;
    $(".change-active-membership-kind").on("click", function(e) {
      e.preventDefault();
      const $target = $(e.target).is("a")
        ? $(e.target)
        : $(e.target).parents("a");
      const kind = $target.hasClass("membership_premium-item")
        ? "membership_premium"
        : "membership_basic";
      const activeKind = self.activeMembershipKind();

      if (kind === activeKind) {
        return true;
      }
      // Update activated kind
      self.updateActiveKind(kind);

      // Only execute if we're on a page with mapping, otherwise skip
      if (typeof window.bikehubLocations !== "undefined") {
        // And rerender the markers, because we've changed the things that are visible!
        window.bikehubLocations.rerenderMarkers();
      }
    });
  }

  updateActiveKind(kind) {
    // Change the color of the markers
    // Set the focus shown after form submission
    $("#membership_kind_focus").val(kind);

    // Only specify verify_id if verify_id is present and on the premium form
    if ($("#verify_id").length) {
      $("#verify_id").val(kind == "membership_premium");
    }

    if (kind == "membership_premium") {
      // Only execute if we're on a page with mapping, otherwise skip
      if (typeof window.bikehubLocations !== "undefined") {
        window.bikehubLocations.shownLocationKinds = [
          "valet_location",
          "bikeep",
          "kiosk_room",
          "bikelink",
          "bike_repair"
        ];
      }
      // Make the premium fields required
      $(".premium-required-field").attr("required", "required");
      // Add active body classes
      $("body")
        .removeClass("membership_basic-active")
        .addClass("membership_premium-active");
    } else {
      // Only execute if we're on a page with mapping, otherwise skip
      if (typeof window.bikehubLocations !== "undefined") {
        window.bikehubLocations.shownLocationKinds = ["valet_location", "bikeep", "bike_repair"];
      }
      // Make the premium fields un-required
      $(".premium-required-field").attr("required", false);
      // Add active body classes
      $("body")
        .removeClass("membership_premium-active")
        .addClass("membership_basic-active");
    }
  }

  activeMembershipKind() {
    return $("body").hasClass("membership_premium-active")
      ? "membership_premium"
      : "membership_basic";
  }
}
